import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

interface AppLogoProps extends SvgIconProps {}

export const AppLogo: FC<AppLogoProps> = ({ ...rest }) => (
  <SvgIcon
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3138 7.20003C19.0388 4.99128 17.0193 3.48195 14.7544 2.80419C15.9863 3.5167 17.0522 4.55167 17.8144 5.87163C20.1347 9.88875 18.7576 15.0264 14.7403 17.3465C10.7222 19.6659 5.58547 18.2887 3.26539 14.2716C2.87258 13.591 2.58571 12.8776 2.39913 12.151C2.42257 13.7335 2.83881 15.332 3.68632 16.8C6.3376 21.392 12.2082 22.9652 16.8002 20.3139C21.3921 17.6626 22.9651 11.7919 20.3138 7.20003ZM17.6589 11.1545C17.5436 10.4673 17.3055 9.78857 16.9361 9.15012C15.2795 6.28044 11.6103 5.29692 8.74058 6.95357C5.8709 8.61106 4.88738 12.2804 6.54403 15.1501C6.91341 15.7885 7.38122 16.3341 7.91841 16.7775C6.44841 16.2038 5.15553 15.1444 4.30521 13.6717C2.64489 10.7965 3.19334 7.25362 5.4227 5.00458C5.91395 4.54332 6.46144 4.12803 7.06144 3.76803C10.487 1.87615 14.8108 3.06864 16.7759 6.47187C17.6262 7.94467 17.8972 9.59379 17.659 11.1547L17.6589 11.1545ZM14.1405 16.3071C16.4364 14.9815 17.2231 12.0461 15.8974 9.75027C14.5718 7.45433 11.6364 6.66771 9.34058 7.99339C7.04464 9.31901 6.25802 12.2544 7.58371 14.5502C8.90932 16.8461 11.8447 17.6328 14.1405 16.3071ZM6.60019 2.64675C6.55425 2.67393 6.50831 2.70018 6.46237 2.72737C6.42206 2.75081 6.38081 2.77331 6.3405 2.79675C5.68331 3.17643 5.09643 3.63113 4.5855 4.14394C1.0239 7.5001 0.0938979 12.9781 2.64675 17.4001C5.62995 22.5656 12.2345 24.3356 17.4003 21.3536C22.5658 18.3704 24.3358 11.7659 21.3538 6.6001C18.3706 1.43458 11.7659 -0.335255 6.60019 2.64675Z"
      fill="currentColor"
    />
  </SvgIcon>
);
